import { Router } from '@angular/router';
import { Component, OnInit, OnDestroy, ChangeDetectorRef, ElementRef, ViewChild } from '@angular/core';
import { Subscription } from 'rxjs';
import { FormBuilder, Validators, FormGroup, FormControl } from '@angular/forms';
import { CustomersService } from '../../../core/services/customers.service';
import { Customer, CustomerBank, DocumentConfig, AccTypes, WorkCategories } from '../../../core/model/customer';
import { TabPermission } from '../../../core/model/navlink';
import { HttpClient, HttpResponse } from '@angular/common/http';
import { MessageService } from 'src/app/core/services/message.service';
import { CurrentTabsService } from 'src/app/core/services/current-tabs.service';
import { UploadDocService } from 'src/app/core/services/upload-doc.service';
// import { saveAs } from 'file-saver';
import { environment } from 'src/environments/environment';
// import { WorkCategoryService } from 'src/app/core/services/work-category.service';

interface ItemData {
  name: string;
  age: string;
  address: string;
}
interface ItemData2 {
  name: string;
  age: string;
  address: string;
}

@Component({
  selector: 'app-customer',
  templateUrl: './customer.component.html',
  styleUrls: ['./customer.component.scss'],
})
export class CustomerComponent implements OnInit, OnDestroy {

  listOfData: ItemData[] = [];
  listOfData2: ItemData2[] = [];

  tabs = [1, 2, 3];

  value?: string;
  radioValue = 'A';

  name = new FormControl('');
  

  constructor(private httpClient: HttpClient) {
    
  }

  ngOnInit() {
    for (let i = 0; i < 100; i++) {
      this.listOfData.push({
        name: 'APS',
        age: 'Kalubhai',
        address: 'General'
      });
    }

    for (let i = 0; i < 100; i++) {
      this.listOfData2.push({
        name: `${i}`,
        age: 'Kalubhai',
        address: 'General'
      });
    }
  } 

  ngOnDestroy(): void {
    // this.subs.unsubscribe();
  }
  isEdit = false;
  visible = false;

  open(): void {
    this.visible = true;
  }

  close(): void {
    this.isEdit = false;
    this.visible = false;
  } 
}